import { useMemo } from 'react';

const PersonCaption = ({ person }) => {

    const num_covoyagers = useMemo(() => {
      if (person === null) {
        return 0;
      }

      let covoyagers = {};
      for (let i in person.person_trips) {
        const trip = person.person_trips[i].trip;
        for (let j in trip.person_trips) {
          const covoyager = trip.person_trips[j].person;
          if (covoyager.person_index === person.person_index) {
            covoyagers[covoyager.person_index] = covoyager.group_size - 1;
          } else {
            covoyagers[covoyager.person_index] = covoyager.group_size;
          }
        }
      }
      return Object.values(covoyagers).reduce((a,b) => a+b, 0);
    }, [person]);

    if (person === null) {
      return null;
    }

    const num_trips = person.person_trips.length;
    const first_trip_text = person.person_trips[0].trip.trip_date;
    const last_trip_text = person.person_trips[num_trips-1].trip.trip_date;
    const trip_dates_text = (num_trips > 1) ? `${first_trip_text} to ${last_trip_text}` : first_trip_text;
    const covoyagers_text = (num_covoyagers > 1) ? `${num_covoyagers} co-voyagers` : `1 co-voyager`;
    const num_trips_text = (num_trips > 1) ? ` across ${num_trips} trips` : "";
    const person_text = `${covoyagers_text}${num_trips_text}`;

    return (
      <g fill="white"
         textAnchor="middle"
         className="person_caption"
         style={{fontSize: 30}}>
        <text dy="-0.45em">{person.name}</text>
        <text dy="1.15em">{trip_dates_text}</text>
        <text dy="2.75em">{person_text}</text>
      </g>
    );
  };

  export default PersonCaption;
